export default "__VITE_ASSET__BFDV3HSI__"